import SendMessageContainer from './SendMessageContainer';

export default SendMessageContainer;
